import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TableModule } from '@lib/modules';
import { TransactionTypePipe, OptionalPlaceholderPipe } from '@lib/pipes';
import { TransferStatusPipe } from '@lib/pipes/transfer-status/transfer-status.pipe';
import { SidePanelService } from '@lib/services';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedSendMoneyComponent } from './shared-send-money.component';

@NgModule({
    declarations: [SharedSendMoneyComponent],
    imports: [CommonModule, AngularMaterialModule, TableModule, TransferStatusPipe, TransactionTypePipe, OptionalPlaceholderPipe, NgOptimizedImage],
    providers: [SidePanelService],
    exports: [TransferStatusPipe, TransactionTypePipe, OptionalPlaceholderPipe, NgOptimizedImage, TableModule, AngularMaterialModule],
})
export class SharedSendMoneyModule {}
